import dialogPolyfill from "dialog-polyfill";

import Alert from "../library/v2/Alert";

import Cookies from "./cookies";
import PreactDOMComponent from "./utils/preact-dom-component";

function createDialog(data, options) {
    const documentBody = document.querySelector("body");

    if (documentBody.classList.contains("genericDialogVisible") && !data) {
        return;
    }

    const {
        title,
        message = "We're experiencing a problem. Please try again and if the problem persists, contact us at support@zeplin.io."
    } = data || {};
    let defer = false;

    if (options && "defer" in options) {
        ({ defer } = options);
    }

    if (defer) {
        sessionStorage.setItem(
            "deferredDialog",
            JSON.stringify({
                title,
                message
            })
        );

        return;
    }

    const dialogContainer = document.createElement("div");
    const AlertComponent = new PreactDOMComponent(Alert, dialogContainer);

    const primaryButtonProps = {
        children: "OK"
    };
    let secondaryButtonProps;

    if (data) {
        if (data.done) {
            const { name: doneName, cb: doneCallback } = data.done;

            if (doneName) {
                primaryButtonProps.children = doneName;
            }

            if (doneCallback) {
                primaryButtonProps.onClick = doneCallback;
            }
        }

        if (data.cancel) {
            const { name: cancelName, cb: cancelCallback } = data.cancel;

            secondaryButtonProps = {
                children: "Cancel"
            };

            if (cancelName) {
                secondaryButtonProps.children = cancelName;
            }

            if (cancelCallback) {
                secondaryButtonProps.onClick = cancelCallback;
            }
        }
    }

    AlertComponent.render({
        title,
        description: message,
        primaryButtonProps,
        secondaryButtonProps,
        onClose: () => AlertComponent.remove()
    });

    if (!data) {
        documentBody.classList.add("genericDialogVisible");
    }

    documentBody.appendChild(dialogContainer);
}

const deferredDialog = JSON.parse(sessionStorage.getItem("deferredDialog"));
if (deferredDialog) {
    sessionStorage.removeItem("deferredDialog");
    createDialog(deferredDialog);
}

const deferredCookieDialog = Cookies.get("deferredDialog");

if (deferredCookieDialog) {
    const dialogContent = JSON.parse(decodeURIComponent(deferredCookieDialog));

    Cookies.remove("deferredDialog");
    createDialog(dialogContent);
}

export { dialogPolyfill as polyfill, createDialog as create };
